module.exports = __webpack_public_path__ + "static/media/woman-with-glasses.0853a3f2.webp";